import * as React from "react";

export const Companies: any = [];

Companies[0] = {
    CompanyName: "MetLife",
    CoexistencesMaxRatio: 0.4,
    InsuranceAmount: {
        MaxValue: 100000,
        Message: `Il Capitale da assicurare non può essere superiore ad 100.000,00 €.`
    },
    DateOfBirth: {
        MinAge: 45,
        MaxAge: 83,
        MaxAgeInsuranceEnd: 85,
        Messages: {
            true_true_false: "All'inizio dell'Ammortamento l'Età del Cedente non può essere inferiore all'età assicurativa minima prevista pari ad anni 45",
            true_false_true: "Il Cedente all'INIZIO del Piano di Ammortamento ha un'età Assicurativa superione a quella  massima prevista pari ad anni 83",
            false_true_true: "Il Cedente alla FINE del Piano di Ammortamento ha un'età Assicurativa superione a quella  massima prevista pari ad anni 85",
            true_true_true: "",
            false_false_true: "Il Cedente all'INIZIO del Piano di Ammortamento ha un'età Assicurativa superione a quella  massima prevista pari ad anni 83"
        }
    },
    Documentation: {
        MaxInsuranceAmount: 70000,
        Messages: {
            false_false_false: "Modulo relativo alle dichiarazioni rese dall'assicurato (DBS)",
            false_false_true: "Modulo Privacy, RVM, Ultimi Esami Clinici (se dichiarati in RVM)",
            true_false_false: "Modulo Privacy, RVM + RVM (Additional), Verbale di Prima Istanza, Ultimi Esami Clinici (se dichiarati in RVM)",
            true_false_true: "Modulo Privacy, RVM + RVM (Additional), Verbale di Prima Istanza, Ultimi Esami Clinici (se dichiarati in RVM)",
            false_true_false: "Modulo Privacy, Questionario Audiolesi, Videolesi e Rendita INAIL, Certificato INAIL (se disponibile)",
            false_true_true: "Modulo Privacy, RVM, Certificato INAIL (se disponibile)",
            true_true_false: "Modulo Privacy, RVM + RVM (Additional), Verbale di Prima Istanza, Ultimi Esami Clinici (se dichiarati in RVM), Certificato INAIL (se disponibile)",
            true_true_true: "Modulo Privacy, RVM + RVM (Additional), Verbale di Prima Istanza, Ultimi Esami Clinici (se dichiarati in RVM), Certificato INAIL (se disponibile)"
        }
    }
};

Companies[1] = {
    CompanyName: "SGI",
    CoexistencesMaxRatio: 0.4,
    InsuranceAmount: {
        MaxValue: 100000,
        Message: "Il Capitale da assicurare non può essere superiore ad 100.000,00 €."
    },
    DateOfBirth: {
        MinAge: 18,
        MaxAge: 83,
        MaxAgeInsuranceEnd: 85,
        Messages: {
            true_true_false: "All'inizio dell'Ammortamento l'Età del Cedente non può essere inferiore all'età assicurativa minima prevista pari ad anni 18",
            true_false_true: "Il Cedente all'INIZIO del Piano di Ammortamento ha un'età Assicurativa superione a quella  massima prevista pari ad anni 83",
            false_true_true: "Il Cedente alla FINE del Piano di Ammortamento ha un'età Assicurativa superione a quella  massima prevista pari ad anni 85",
            true_true_true: "",
            false_false_true: "Il Cedente all'INIZIO del Piano di Ammortamento ha un'età Assicurativa superione a quella  massima prevista pari ad anni 83"
        }
    },
    Documentation: {
        MaxInsuranceAmount: 70000,
        Messages: {
            false_false_false: "Questionario Medico (QM)",
            false_false_true: "RVM, Modulo Privacy",
            true_false_false: "RVM, Modulo Privacy, Verbale di Prima Istanza (se non reperibile specificare su RVM la % Invalidità e la patologia)",
            true_false_true: "RVM, Modulo Privacy, Verbale di Prima Istanza (se non reperibile specificare su RVM la % Invalidità e la patologia)",
            false_true_false: "RVM, Modulo Privacy, Certificato INAIL (se non reperibile specificare su RVM la % Invalidità e la patologia)",
            false_true_true: "RVM, Modulo Privacy, Certificato INAIL (se non reperibile specificare su RVM la % Invalidità e la patologia)",
            true_true_false:
                " RVM, Modulo Privacy, Verbale di Prima Istanza (se non reperibile specificare su RVM la % Invalidità e la patologia), Certificato INAIL (se non reperibile specificare in RVM la % Invalidità e la patologia)",
            true_true_true:
                " RVM, Modulo Privacy, Verbale di Prima Istanza (se non reperibile specificare su RVM la % Invalidità e la patologia), Certificato INAIL (se non reperibile specificare in RVM la % Invalidità e la patologia)"
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/DigitalProductAnalyser/configPensioners.ts